//LOGO
export const LOGO = '/assets/svg/logo_light.svg'
export const SITE_NAME = 'The Time To Give Network'

export const FALLBACK_IMAGE = (e) => {
    e.target.src = '/assets/images/noImage.png'
}
